import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FunctionComponent } from 'react';
import styles from './BrandColorsPreview.module.scss';

interface BrandColorsPreviewProps {
    primaryColor: string;
    secondaryColor: string;
}

const BrandColorsPreview: FunctionComponent<BrandColorsPreviewProps> = props => {
    return (
        <div className={styles.container}>
            <p className={styles.title}>Preview</p>
            <p className={styles.description}>This is how your selected colors will appear.</p>
            <div className={styles.card}>
                <div className={styles.block}>
                    <div className={styles.progressGroup}>
                        <p className={styles.progressLabel}>Progress indicator</p>
                        <div className={styles.progressTrack}>
                            <div
                                className={styles.progressFill}
                                style={{ backgroundColor: props.primaryColor }}
                            />
                        </div>
                    </div>
                    <div
                        className={styles.actionButton}
                        style={{ backgroundColor: props.primaryColor }}
                    >
                        Continue
                    </div>
                    <p className={styles.caption}>Primary Action</p>
                </div>
                <div className={styles.divider} />
                <div className={styles.block}>
                    <div
                        className={styles.actionButton}
                        style={{ backgroundColor: props.secondaryColor }}
                    >
                        <FontAwesomeIcon icon={faPlus} />
                        Add emergency contact
                    </div>
                    <p className={styles.caption}>Secondary Action</p>
                </div>
            </div>
        </div>
    );
};

export default BrandColorsPreview;
